/**
 * There will be one saga file per component
 */
import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import {
    GET_HYBRIS_USER_DETAILS_SUCCESS,
    GET_HYBRIS_USER_DETAILS_FAILURE,
    SET_LOGOUT_SUCCESS,
    SET_LOGOUT_FAILURE,
} from './../actions/constants';
import { errorHandler } from 'src/errorHandler/errorHandler';
import {
    checkImpersonationActive,
    checkProxyActive,
    setUserData,
    validateUserRole,
} from 'src/utils/util';
import { getImpersonationUserData } from 'src/pages/impersonation/redux/actions';
import {
    JAPAN_SALESORG,
    IMPERSONATED_URL,
} from 'src/constants/appConstants';
import i18n from 'src/i18n';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export function* getHybrisUserDetails() {
    const url = IMPERSONATED_URL;

    try {
        const result = yield axios.get(url).then((response) => response.data);
        if (checkImpersonationActive() || checkProxyActive()) {
            yield put(getImpersonationUserData());
        }
        setUserData(result);
        result?.englishPreferred != 'Y' &&
        result?.languageISOCode === 'ja' &&
        result?.salesOrgs &&
        result?.salesOrgs[0] === JAPAN_SALESORG
            ? i18n.changeLanguage('ja')
            : i18n.changeLanguage('en');

        yield put({
            type: GET_HYBRIS_USER_DETAILS_SUCCESS,
            payload: {
                ...result,
                isLanguageChanged:
                    // true ||
                    result?.englishPreferred != 'Y' &&
                    result?.languageISOCode === 'ja' &&
                    result?.salesOrgs &&
                    result?.salesOrgs[0] === JAPAN_SALESORG,
            },
        });
        if (validateUserRole(result.employeeRole)) {
            localStorage.setItem('userAuthenticated', true);
        }
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
        });
        localStorage.removeItem('userAuthenticated');
        yield put({
            type: GET_HYBRIS_USER_DETAILS_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* logout() {
    const url = '/mycaseauthserver/oauth/revoke';

    try {
        const result = yield axios.get(url).then((response) => response.data);

        yield put({
            type: SET_LOGOUT_SUCCESS,
            payload: { ...result },
        });
        localStorage.removeItem('userAuthenticated');
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
        });
        yield put({
            type: SET_LOGOUT_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
